'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_Freemium2FAAddView$$anon$17() {
}
export { $c_Lpresto_Freemium2FAAddView$$anon$17 as $c_Lpresto_Freemium2FAAddView$$anon$17 };
$p = $c_Lpresto_Freemium2FAAddView$$anon$17.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_sr_AbstractPartialFunction();
$p.constructor = $c_Lpresto_Freemium2FAAddView$$anon$17;
/** @constructor */
function $h_Lpresto_Freemium2FAAddView$$anon$17() {
}
export { $h_Lpresto_Freemium2FAAddView$$anon$17 as $h_Lpresto_Freemium2FAAddView$$anon$17 };
$h_Lpresto_Freemium2FAAddView$$anon$17.prototype = $p;
$p.sE = (function(x) {
  if ((x !== null)) {
    var x101 = x.X();
    x.Y();
    if ((x101 !== null)) {
      var x104 = x101.DS;
      if ((x104 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some)) {
        return true;
      }
    }
  }
  return false;
});
$p.so = (function(x, default$1) {
  if ((x !== null)) {
    var x109 = x.X();
    var s = x.Y();
    if ((x109 !== null)) {
      var x112 = x109.DS;
      if ((x112 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some)) {
        var err = x112.a0;
        return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T2(s.KL, err);
      }
    }
  }
  return default$1.w(x);
});
$p.cb = (function(x) {
  return this.sE(x);
});
$p.bk = (function(x, default$1) {
  return this.so(x, default$1);
});
var $d_Lpresto_Freemium2FAAddView$$anon$17 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Freemium2FAAddView$$anon$17, "presto.Freemium2FAAddView$$anon$17", ({
  Ji: 1,
  a4: 1,
  t: 1,
  A: 1,
  a: 1
}));
export { $d_Lpresto_Freemium2FAAddView$$anon$17 as $d_Lpresto_Freemium2FAAddView$$anon$17 };
//# sourceMappingURL=presto.-Freemium2-F-A-Add-View$$anon$17.js.map
